import { homeContent } from "../data/mockHome";

export function CaseStudiesPage() {
  return (
    <div className="bg-slate-950 py-24">
      <div className="mx-auto max-w-6xl px-6">
        <header className="max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-emerald-300">
            Case Studies
          </p>
          <h1 className="mt-4 text-4xl font-semibold text-white">
            Mission-critical environments need workflows that deliver measurable outcomes.
          </h1>
          <p className="mt-4 text-slate-300">
            Explore how AVUX translated complex requirements into adoption, revenue, and readiness gains.
          </p>
        </header>
        <div className="mt-16 grid gap-6 md:grid-cols-2">
          {homeContent.caseStudies.map((study) => (
            <article
              key={study.title}
              className="overflow-hidden rounded-3xl border border-white/10 bg-slate-900/60"
            >
              <img
                src={study.image}
                alt={`${study.title} visual`}
                className="h-56 w-full object-cover"
              />
              <div className="space-y-3 px-8 py-8">
                <div className="text-xs font-semibold uppercase tracking-[0.3em] text-emerald-300">
                  {study.subtitle}
                </div>
                <h2 className="text-2xl font-semibold text-white">{study.title}</h2>
                <p className="text-sm text-slate-300">{study.metric}</p>
                <button className="text-sm font-medium text-emerald-300 hover:text-emerald-200">
                  View case study →
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
